import { useCallback, useEffect, useRef, useState } from "react";

export default function Optional({
  type,
  optional,
  price,
  setPrice,
  setAddToCart,
}) {
  const [addOptional, setAddOptional] = useState(false);
  const [removeOptional, setRemoveOptional] = useState(false);

  const handleAddOptional = useCallback(() => {
    const optionalPrice = Number(optional.product.price);

    setPrice((currentPrice) => {
      if (isNaN(currentPrice)) return currentPrice;

      return Number((Number(currentPrice) + optionalPrice).toFixed(2));
    });
    setAddToCart((prod) => ({
      ...prod,
      added: [...(prod.added || []), optional.product],
    }));
  }, [optional.product, setAddToCart, setPrice]);

  const handleRemoveAddOptional = useCallback(() => {
    const optionalPrice = Number(optional.product.price);

    setAddToCart((prod) => ({
      ...prod,
      added: (prod?.added || []).filter((i) => {
        return i.id !== optional.product.id;
      }),
    }));
    setPrice((currentPrice) => {
      if (isNaN(currentPrice)) return currentPrice;

      return Number((Number(currentPrice) - optionalPrice).toFixed(2));
    });
  }, [optional.product.id, optional.product.price, setAddToCart, setPrice]);

  const isInitialMountAdd = useRef(true);
  const isInitialMountRemove = useRef(true);

  useEffect(() => {
    if (isInitialMountAdd.current) {
      isInitialMountAdd.current = false; // Toggle the ref after the first render
    } else {
      // This code will only run if addOptional changes after the initial render
      addOptional ? handleAddOptional() : handleRemoveAddOptional();
    }
  }, [addOptional, handleAddOptional, handleRemoveAddOptional]);

  const handleRemoveOptional = useCallback(() => {
    setAddToCart((prod) => ({
      ...prod,
      removed: [...(prod?.removed || []), optional.product],
    }));
  }, [optional.product, setAddToCart]);

  const handleRemoveRemoveOptional = useCallback(() => {
    setAddToCart((prod) => ({
      ...prod,
      removed: (prod?.removed || []).filter((i) => {
        return i.id !== optional.product.id;
      }),
    }));
  }, [optional.product.id, setAddToCart]);

  useEffect(() => {
    if (isInitialMountRemove.current) {
      isInitialMountRemove.current = false; // Toggle the ref after the first render
    } else {
      // This code will only run if removeOptional changes after the initial render
      removeOptional ? handleRemoveOptional() : handleRemoveRemoveOptional();
    }
  }, [removeOptional, handleRemoveOptional, handleRemoveRemoveOptional]);

  return (
    <div className="item">
      <input
        type="checkbox"
        id={optional.id}
        onChange={() =>
          type === "add"
            ? setAddOptional(!addOptional)
            : setRemoveOptional(!removeOptional)
        }
      />
      <label for={optional.id}>
        {type === "add"
          ? `${optional.product.name} (+${optional.product.price})`
          : `${optional.product.name}`}
      </label>
    </div>
  );
}
